import { render, staticRenderFns } from "./newssix.vue?vue&type=template&id=3d5beff7&scoped=true"
var script = {}
import style0 from "./newssix.vue?vue&type=style&index=0&id=3d5beff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5beff7",
  null
  
)

export default component.exports